<template lang="html">
  <v-row v-if="items && items.length > 0" v-bind="$attrs">
    <v-col
      class="pa-1 pa-sm-2"
      v-for="(item, index) in items"
      :style="_colStyle"
      :class="colClass"
      :key="item.id || `item-${index}`"
      v-bind="_colProps"
    >
      <slot :item="item" :index="index" />
    </v-col>
  </v-row>
</template>

<script>
import { omitBy } from 'lodash';

export default {
  name: 'BaseGrid',
  props: {
    items: {
      // TODO: allow Number type for generating an amount of indeterminate items (e.g. days in taskplanning)
      type: Array,
      required: true,
    },
    columns: {
      // any number of columns, doesn't need to be divisible by 12. Must control breakpoints  yourself.
      type: [Number, String],
      default: 0,
      validator: v => {
        let n = Number.parseInt(v, 10);
        return typeof n === 'number' && !Number.isNaN(n);
      },
    },
    colProps: {
      // apply props to v-col https://vuetifyjs.com/en/api/v-col/#links
      // columns prop overrides sizes set by this method
      type: Object,
      default: () => ({ cols: 6, sm: 4, lg: 3 }),
    },
    colClass: {
      // apply classes to the v-col element(s)
      type: [String, Array, Object],
      default: () => ({}),
    },
  },
  computed: {
    _columns() {
      return Number.parseInt(this.columns, 10) || 0; // return 0 for handling default case (because 0 is not divisible and needs to be excepted anyway)
    },
    _colStyle() {
      return (
        this._columns > 0 && `width: ${100 / this._columns}%; flex: 0 0 auto;`
      );
    },
    _colProps() {
      if (this._columns === 0) return this.colProps;

      return omitBy(
        // faster than regular omit
        this.colProps,
        v => (v >= 1 && v <= 12) || v === 'auto'
      );
    },
  },
};
</script>
